








































































import ToTopPage from '@/components/molecules/ToTopPage.vue'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { OrderSummary } from '@/models/order/summary'
import { formatPrice } from '@/util/format'
import { PluginMixin } from '@spa/mixins/plugin'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    ToTopPage,
  },
})
export default class Summary extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ required: true })
  behavior: BehaviorConfig

  @Prop({ required: true })
  summary: OrderSummary

  @Prop({ default: false })
  isFirstShareItem: boolean

  status: Status = Status.Pending

  get total(): string {
    return formatPrice(this.summary.paymentPrice.total)
  }
  get subtotal(): string {
    return formatPrice(this.summary.paymentPrice.subtotal)
  }

  get totalShipping(): string {
    return formatPrice(this.summary.paymentPrice.shipping.total)
  }

  get totalCommission(): string {
    return formatPrice(this.summary.paymentPrice.commission.total)
  }

  get isLoading() {
    return this.status === Status.Loading
  }

  get useCarat(): boolean {
    return this.behavior.useCarat
  }

  mounted() {
    this.scrollToTop()
  }

  scrollToTop() {
    const scrolled = (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop

    // tslint:disable-next-line
    window.scrollTo(0, Math.floor(scrolled / 2))
    if (scrolled > 0) {
      // tslint:disable-next-line
      window.setTimeout(this.scrollToTop, 30);
    }
  }
}

enum Status {
  Pending,
  Loading,
  Failed,
  Completed,
}
